<template>
  <div class="info h-100 bg-black-05 overflow-y-scroll textColor">
    <div v-show="loading" class="flex justify-center items-center h5">
      <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
    </div>
    <p class="pa2 center tc textColor" v-show="!loading && !hasPlaylists">{{ $t("artists.hasNotPlaylists") }}</p>
    <playlist-list :playlists="artistPlaylists" :inArtistProfile="true"></playlist-list>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PlaylistList from '@/components/playlists/PlaylistList.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  name: 'artist-playlists',
  data () {
    return {
      color: '#808080',
      size: '10px'
    }
  },
  created () {
    if (this.artistPlaylists.length === 0) {
      this.getArtistPlaylists(this.artist.id).catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    }
  },
  components: {
    PlaylistList,
    PulseLoader
  },
  computed: {
    ...mapGetters('artist', [
      'artist',
      'artistPlaylists',
      'error'
    ]),
    loading () {
      return this.$loading.isLoading('artist getArtistPlaylists')
    },
    hasPlaylists () {
      return this.artistPlaylists.length > 0
    }
  },
  methods: {
    ...mapActions('artist', [
      'getArtistPlaylists'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/artistProfile/ArtistPlaylists.vue